<template>
  <div>
    <b-alert v-if="readonly" show variant="light" class="mb-3">
      Target triennium:
      <strong>{{ trienniumLabel(targetTrienniumNumber) }}</strong>
      <span v-if="targetsNextTriennium" class="text-muted">
        — changes apply when staged for the next triennium and the current triennium
        setting is switched to that period.
      </span>
    </b-alert>

    <b-form-group
      v-else
      label="Target triennium"
      label-class="font-weight-bold"
    >
      <b-form-radio-group
        :checked="value"
        :options="options"
        stacked
        @input="$emit('input', $event)"
      />
      <b-form-text v-if="value === 'next'">
        Changes will be staged for the next triennium. The public Technical Areas page stays unchanged
        until Admin switches the current triennium setting to that period.
      </b-form-text>
    </b-form-group>
  </div>
</template>

<script>
import Triennium from '@/helpers/triennium';

export default {
  name: 'TargetTrienniumField',
  props: {
    value: {
      type: String,
      default: 'current',
    },
    targetTrienniumNumber: {
      type: Number,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentTrienniumNumber() {
      const fromSettings = this.$store.getters['settings/currentTriennium'];

      return fromSettings ?? Triennium.calculateNumberFromYear();
    },
    options() {
      const current = new Triennium(this.currentTrienniumNumber);
      const next = new Triennium(this.currentTrienniumNumber + 1);

      return [
        {
          value: 'current',
          text: `Current triennium (${current.from()}–${current.to()})`,
        },
        {
          value: 'next',
          text: `Next triennium (${next.from()}–${next.to()})`,
        },
      ];
    },
    targetsNextTriennium() {
      if (!this.targetTrienniumNumber) {
        return false;
      }

      return this.targetTrienniumNumber > this.currentTrienniumNumber;
    },
  },
  methods: {
    trienniumLabel(number) {
      const triennium = new Triennium(number);

      return `${triennium.from()}–${triennium.to()}`;
    },
  },
};
</script>
